import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';


import { AuthenticationService } from './authentication.service';
import { StaticDataService } from './static-data.service';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from './shared-data.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { GoogleAnalyticsService } from './google-analytics.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    counter = 0;

    constructor(
        private authenticationService: AuthenticationService,
        private snotify: SnotifyService,
        private sharedService: SharedDataService,
        private router: Router,
        private gaService:GoogleAnalyticsService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        // add authorization header with jwt token if available
        let token = null;

        if (localStorage.getItem(StaticDataService.tokenLiteral)) {
            token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
        }

        if (token && (!request.url.includes('stg-smartcast') && !request.url.includes('videocmsbp'))) {
            const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ` + token.access_token,
                    Domain: domain
                    // 'Cache-Control': 'no-cache, no-store'
                }
            });
        }

        // console.log(request);
        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                // do stuff with response if you want
            }
        }, (err: any) => {
            // console.log(err);
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401 && (this.counter === 0)) {
                    // redirect to the login route
                    // or show a modal
                    // const token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
                    this.counter = 1;
                    if (token) {
                        this.snotify.warning('Please login again.', 'Session expired', this.sharedService.getConfig(false));
                        this.router.navigate(['/login']);
                        setTimeout(e2 => {
                            this.counter = 0;
                        }, 700);
                    }
                    this.authenticationService.logout();
                } else if (err.status === 0) {
                    console.log('server is returning 0');
                } else if (err.status === 500) {
                    // redirect to the login route
                    // or show a modal
                    // 500 : Failed. Please retry. Please send a mail to blankpaper.support@htdigital.in
                    // console.log(err.error, err.message);
                    this.snotify.clear();
                    this.snotify.error('Please retry', '500 : Failed', this.sharedService.getConfig(false));
                    this.snotify.info('Please send a mail to blankpaper.support@htdigital.in', '', this.sharedService.getConfig(false));

                }else if(err.status === 400){
                    //removed && err.error === 'Duplicate Notification Headline'
                   //for NC-24903
                   if(err && err.error && err.error.errorMessage)
                   {
                    if(!err.error.errorMessage && err.error.errorMessage.indexOf('low')) {
                        this.snotify.error(err.error.errorMessage, this.sharedService.getConfig(false));
                    }
                   }else {
                    if(err && err.error && err.error['error_description']){
                      this.snotify.error(err.error['error_description'], this.sharedService.getConfig(false));
                    }
                    else{
                    this.snotify.error(err.error, this.sharedService.getConfig(false));
                    }
                   }
                }else {
                    if (
                        ( (Math.floor(err.status / 100) === 4) || (Math.floor(err.status / 100) === 5) )
                        && (StaticDataService.codeForSeperateMessage.indexOf(err.status) > -1)) {
                        this.snotify.clear();
                        if(err.status === 400){
                          this.snotify.error(err.error.errorMessage, '', this.sharedService.getConfig(false));
                        } else {
                        this.snotify.error(err.error, 'Code:' + String(err.status), this.sharedService.getConfig(false));
                        }
                      }
                }
                this.googleAnalytics(err,request);
            }
        }));

    }

    googleAnalytics(err,request){
    if(err.status!==401){
        let eventCategory='Error';
        let tenantName=sessionStorage.getItem(StaticDataService.tenantName);
        let eventAction=tenantName +" "+ JSON.stringify(err);
        let eventLabel=request.url;
        let eventValue=err.status;
        this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
      }
    } 
}
